/**
 * @generated SignedSource<<be92bf663d38b24af90b86b4979bf2d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MaintenanceLogSortField = "ADMIN_USER_ID" | "CREATED_ON" | "HARDWARE_OLD_ID" | "ID" | "LOCATION_ID" | "MAINTENANCE_TASK_OLD_ID" | "MAINTENANCE_TICKET_OLD_ID" | "NOTES" | "OLD_ID" | "ORGANIZATION_ID" | "SYSTEM_ID" | "SYSTEM_OLD_ID" | "TIME_TRACKING" | "VALIDATION_DATA" | "%future added value";
export type SortOrder = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type MaintenanceLogSortInput = {
  field: MaintenanceLogSortField;
  order?: SortOrder | null | undefined;
};
export type useHardwareLogsRelayQuery$variables = {
  id: string;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  sort?: ReadonlyArray<MaintenanceLogSortInput | null | undefined> | null | undefined;
};
export type useHardwareLogsRelayQuery$data = {
  readonly getHardware: {
    readonly id: string;
    readonly maintenanceLogs: ReadonlyArray<{
      readonly adminUser: {
        readonly email: string;
        readonly firstName: string;
        readonly id: string;
        readonly lastName: string;
      } | null | undefined;
      readonly adminUserId: string;
      readonly createdOn: any;
      readonly hardwareOldId: string | null | undefined;
      readonly id: string;
      readonly location: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly locationId: string | null | undefined;
      readonly maintenanceTask: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly maintenanceTaskOldId: string;
      readonly maintenanceTicket: {
        readonly description: string;
        readonly id: string;
        readonly oldId: string | null | undefined;
      } | null | undefined;
      readonly maintenanceTicketOldId: string | null | undefined;
      readonly notes: string | null | undefined;
      readonly oldId: string | null | undefined;
      readonly organizationId: string | null | undefined;
      readonly systemId: string | null | undefined;
      readonly systemOldId: string;
      readonly timeTracking: number;
    }>;
  } | null | undefined;
};
export type useHardwareLogsRelayQuery = {
  response: useHardwareLogsRelayQuery$data;
  variables: useHardwareLogsRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "limit"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offset"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sort"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oldId",
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Hardware",
    "kind": "LinkedField",
    "name": "getHardware",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
          },
          {
            "kind": "Variable",
            "name": "offset",
            "variableName": "offset"
          },
          {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
          }
        ],
        "concreteType": "MaintenanceLog",
        "kind": "LinkedField",
        "name": "maintenanceLogs",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeTracking",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adminUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hardwareOldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maintenanceTaskOldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maintenanceTicketOldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "systemId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "systemOldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AdminUser",
            "kind": "LinkedField",
            "name": "adminUser",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MaintenanceTask",
            "kind": "LinkedField",
            "name": "maintenanceTask",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MaintenanceTicket",
            "kind": "LinkedField",
            "name": "maintenanceTicket",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Location",
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useHardwareLogsRelayQuery",
    "selections": (v4/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHardwareLogsRelayQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "baa2b90e4893c51035d9b46410718928",
    "id": null,
    "metadata": {},
    "name": "useHardwareLogsRelayQuery",
    "operationKind": "query",
    "text": "query useHardwareLogsRelayQuery(\n  $id: ID!\n  $limit: Int\n  $offset: Int\n  $sort: [MaintenanceLogSortInput]\n) {\n  getHardware(id: $id) {\n    id\n    maintenanceLogs(limit: $limit, offset: $offset, sort: $sort) {\n      id\n      oldId\n      createdOn\n      notes\n      timeTracking\n      adminUserId\n      hardwareOldId\n      maintenanceTaskOldId\n      maintenanceTicketOldId\n      locationId\n      systemId\n      systemOldId\n      organizationId\n      adminUser {\n        id\n        email\n        firstName\n        lastName\n      }\n      maintenanceTask {\n        id\n        name\n      }\n      maintenanceTicket {\n        id\n        oldId\n        description\n      }\n      location {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8c8b6232554c7f27f7b1e383661d03c3";

export default node;
